export const whatMovesUsEs = {
  whatMovesUs_pageTitle: "Lo que nos mueve",
  whatMovesUs_intro:
    "Jandi nació de una observación simple: Puerto Rico tiene talento. Lo que le falta es estructura.",
  whatMovesUs_body:
    "Vimos a miles de profesionales excelentes trabajando en un sistema informal, sin visibilidad ni respaldo. Y vimos a familias perdiendo horas buscando a alguien confiable para resolver algo en su hogar. Eso nos movió a construir Jandi",

  whatMovesUs_s1Title: "Confianza como punto de partida",
  whatMovesUs_s1Body:
    "Todo proveedor en jandi pasa por preverificación antes de aparecer visible. No publicamos perfiles incompletos. La confianza no se improvisa, se construye con estándares.",

  whatMovesUs_s2Title: "Hecho para Puerto Rico",
  whatMovesUs_s2Body:
    "No somos una plataforma global adaptada. Somos un proyecto construido desde aquí, para aquí. Entendemos el mercado, la cultura y la manera en que se trabaja en la isla.",

  whatMovesUs_s3Title: "Menos fricción, más resolución",
  whatMovesUs_s3Body:
    "El tiempo de las personas vale. Por eso diseñamos la experiencia para que resolver un servicio sea rápido, claro y sin complicaciones del primer clic al pago.",

  whatMovesUs_s4Title: "Respaldo en cada paso",
  whatMovesUs_s4Body:
    "Si algo no sale como esperabas, estamos aquí. Jandi tiene soporte formal para atender cualquier situación, no desaparecemos después de la conexión.",

  whatMovesUs_s5Title: "Una comunidad, no solo una app",
  whatMovesUs_s5Body:
    "Cada proveedor que se une construye reputación real e historial visible. Queremos que el talento en Puerto Rico se quede, crezca y sea reconocido.",

  whatMovesUs_quote:
    "\"Puerto Rico tiene talento. Queremos que se quede y que este siempre a la mano.\"",
};
